/* eslint-disable quotes */
/* eslint-disable quote-props */
import { v4 as uuid } from 'uuid';

// schema mock of the expected car object
// {
//     "grade-engine": "Sport|i-MMD",
//     "grade-engine-code": "Sport|11",
//     "car-color": "Sonic Grey Pearl",
//     "car-color-code": "NH-877P",
//     "car-base-price": 36495,
//     "car-total-price": 36495,
//     "car-trim": "Black Synthetic Leather with Fabric",
//     "car-trim-code": "HLB",
//     "car-short-url": "localhost/SUnLiN",
//     "car-long-url": "http://localhost/templates_inclusive/pages/pt_configurator_lite/index.shtml#configurator/hub/summary?isCarConfigurator=true&grade=Sport&engine=11-ECVT&colour=HLBNH-877P&accessories=wheel-sport",
//     "selected-servicing": false,
//     "selected-accessories": "18\\" Gloss Black Alloys",
//     "accessories-without-standard-alloys": "",
//     "car-model-name": "Civic Hybrid",
//     "car-selected-image": {
//       "tiny": "https://configurator-images.honda.eu/content/dam/configuratorHub/civic-hybrid-2023/grades/sport-uk/f34-stu/CivicHybrid2023-Sport-NH-877P-f34-stu.png/jcr:content/renditions/tiny.png",
//       "extraSmall": "https://configurator-images.honda.eu/content/dam/configuratorHub/civic-hybrid-2023/grades/sport-uk/f34-stu/CivicHybrid2023-Sport-NH-877P-f34-stu.png/jcr:content/renditions/extrasmall.png",
//       "small": "https://configurator-images.honda.eu/content/dam/configuratorHub/civic-hybrid-2023/grades/sport-uk/f34-stu/CivicHybrid2023-Sport-NH-877P-f34-stu.png/jcr:content/renditions/small.png",
//       "medium": "https://configurator-images.honda.eu/content/dam/configuratorHub/civic-hybrid-2023/grades/sport-uk/f34-stu/CivicHybrid2023-Sport-NH-877P-f34-stu.png/jcr:content/renditions/medium.png",
//       "large": "https://configurator-images.honda.eu/content/dam/configuratorHub/civic-hybrid-2023/grades/sport-uk/f34-stu/CivicHybrid2023-Sport-NH-877P-f34-stu.png/jcr:content/renditions/large.png",
//       "extraLarge": "https://configurator-images.honda.eu/content/dam/configuratorHub/civic-hybrid-2023/grades/sport-uk/f34-stu/CivicHybrid2023-Sport-NH-877P-f34-stu.png/jcr:content/renditions/extralarge.png",
//       "superLarge": "https://configurator-images.honda.eu/content/dam/configuratorHub/civic-hybrid-2023/grades/sport-uk/f34-stu/CivicHybrid2023-Sport-NH-877P-f34-stu.png/jcr:content/renditions/superlarge.png"
//     }
//   }

export default class SaveConfiguration {
    constructor() {
        this.saveCarConfText = 'save-for-later';
    }

    setConfiguredCar(carObj) {
        const self = this;
        const saveCarConfObj = {
            type: 'HondaCarConfiguratorOffer',
            id: uuid(),
            synced: false,
            model: carObj['car-model-name']?.toLowerCase().replace(' ', '-').trim(),
            vehicleName: carObj['car-vehicle-name'],
            carBasePrice: +carObj['car-base-price'],
            carTotalPrice: +carObj['car-total-price'],
            trim: carObj['car-trim'],
            carTrimCode: carObj['car-trim-code'],
            carShortUrl: carObj['car-short-url'],
            carLongUrl: carObj['car-long-url'],
            gradeEngine: carObj['grade-engine'],
            gradeEngineCode: carObj['grade-engine-code'],
            carColour: carObj['car-color'],
            carColourCode: carObj['car-color-code'],
            selectedAccessoriesWithoutStandardAlloys: carObj['accessories-without-standard-alloys'],
            specId: 'null',
            financeOfferDesc: carObj['finance-offer-description'],
            financeParams: {
                financeOfferTerm: carObj['finance-offer-term'],
                financeOfferMileage: carObj['finance-offer-mileage'],
                financeOfferDeposit: carObj['finance-offer-deposit'],
                financeOfferType: carObj['finance-offer-type'],
                financeFinalPayment: carObj['finance-final-payment'],
                financeHondaDeposit: carObj['finance-honda-deposit'],
                financeInterestRate: carObj['finance-interest-rate'],
                financeInterestRateRepresentative: carObj['finance-interest-rate-representative'],
                financeOfferExpiry: carObj['finance-offer-expiry'],
                financeMonthlyInstallment: carObj['finance-monthly-installment'],
            },
            servicingSelected: carObj['selected-servicing'],
            shareWithDealer: false,
            carSelectedImage: carObj['car-selected-image'],
            carColorSelectedImage: carObj['car-color-Image'],
            dateCreated: new Date().toISOString(),
        };

        if (carObj && typeof carObj === 'object' && carObj.constructor === Object) {
            const getSavedCarConfiguration = JSON.parse(localStorage.getItem(self.saveCarConfText)) || [];
            getSavedCarConfiguration.push(saveCarConfObj);
            localStorage.setItem(self.saveCarConfText, JSON.stringify(getSavedCarConfiguration));
        }
    }

    getSavedCount() {
        return SaveConfiguration.getSavedCars().length;
    }

    updateSavedCountInNavigation() {
        SaveConfiguration.updateSavedCountInNavigation();
    }

    static getSavedCars() {
        const savedCars = JSON.parse(localStorage.getItem('save-for-later')) || [];
        return savedCars;
    }

    static updateSavedCountInNavigation() {
        const savedItemCount = SaveConfiguration.getSavedCars().length;
        const savedItemCountElements = document.querySelectorAll('.saved-item-count');

        savedItemCountElements.forEach((itemElement) => {
            const savedItemLink = itemElement.closest('[data-saved-items-aria-label]');

            if (savedItemCount > 0) {
                const itemsCountText = parseInt(savedItemCount, 10) > 9 ? '9+' : savedItemCount;
                itemElement.textContent = itemsCountText;
                itemElement.style.display = 'block';
                savedItemLink &&
                    savedItemLink.setAttribute(
                        'aria-label',
                        savedItemLink.dataset.savedItemsAriaLabel.replace('{0}', itemsCountText),
                    );
            } else {
                itemElement.textContent = 0;
                itemElement.style.display = 'none';
                savedItemLink &&
                    savedItemLink.setAttribute(
                        'aria-label',
                        savedItemLink.dataset.savedItemsAriaLabel.replace('{0}', '0'),
                    );
            }
        });
    }
}

window.HONDA = window.HONDA || {};
window.HONDA.SaveConfiguration = new SaveConfiguration();
